/* Find A Gift mega menu — recipient/occasion hover preview swap.
   1:1 with design site behavior: pointerover commits a swap after a 60ms
   delay, pointerout cancels; new image fades in as an absolutely-positioned
   layer over the old one (container size never changes); the group being
   explored is pre-warmed one image at a time; keyboard focus swaps too;
   prefers-reduced-motion skips the fade. */
(function () {
  'use strict';

  var CONFIG = window.CS_GIFT_PREVIEW || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var timers = new WeakMap();      /* control -> pending swap timer */
  var warmedGroups = new WeakSet(); /* one warm pass per group */

  function assetFor(control) {
    return CONFIG[control.dataset.giftPreview];
  }

  function photoFor(control) {
    var group = control.closest('.cs-fg__group');
    return group ? group.querySelector('.cs-fg__photo[data-gift-preview-current]') : null;
  }

  function buildLayer(asset) {
    var layer = document.createElement('div');
    layer.className = 'cs-fg__preview-layer';
    layer.setAttribute('data-gift-preview-layer', '');
    var img = document.createElement('img');
    img.src = asset.src;
    img.alt = asset.alt || '';
    img.width = 400; img.height = 500;
    img.loading = 'eager';
    img.decoding = 'sync';
    layer.appendChild(img);
    return layer;
  }

  function commit(control) {
    var asset = assetFor(control);
    if (!asset || !asset.src) return;
    var photo = photoFor(control);
    if (!photo) return;
    if (photo.dataset.giftPreviewCurrent === control.dataset.giftPreview) return;

    var layer = buildLayer(asset);
    /* If the custom image fails to load (bad upload / removed file), roll back
       without touching the visible image. */
    layer.querySelector('img').addEventListener('error', function () {
      if (layer.parentNode) layer.remove();
    });

    photo.appendChild(layer);
    photo.dataset.giftPreviewCurrent = control.dataset.giftPreview;
    photo.setAttribute('aria-label', asset.alt || '');

    var retireOlderLayers = function () {
      while (layer.previousElementSibling) layer.previousElementSibling.remove();
    };

    if (reduceMotion.matches || !layer.animate) {
      retireOlderLayers();
    } else {
      /* Old image stays opaque under the new one, including interrupted fades. */
      layer.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 240, easing: 'ease-out', fill: 'forwards'
      }).addEventListener('finish', retireOlderLayers);
    }

    var group = control.closest('.cs-fg__group');
    if (group) {
      group.querySelectorAll('[data-gift-preview]').forEach(function (item) {
        if (item === control) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
    }
  }

  function schedule(control, delayed) {
    cancel(control);
    if (photoFor(control) &&
        photoFor(control).dataset.giftPreviewCurrent === control.dataset.giftPreview) {
      markCurrent(control);
      return;
    }
    if (delayed) {
      var t = window.setTimeout(function () {
        timers.delete(control);
        commit(control);
      }, 60);
      timers.set(control, t);
    } else {
      commit(control);
    }
  }

  function markCurrent(control) {
    var group = control.closest('.cs-fg__group');
    if (!group) return;
    group.querySelectorAll('[data-gift-preview]').forEach(function (item) {
      if (item === control) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
  }

  function cancel(control) {
    var t = timers.get(control);
    if (t) { window.clearTimeout(t); timers.delete(control); }
  }

  /* Warm only the group being explored, one request at a time, and only
     while its panel is actually open. */
  function warmGroup(group) {
    if (!group || warmedGroups.has(group)) return;
    warmedGroups.add(group);
    window.setTimeout(function () {
      var keys = Array.from(group.querySelectorAll('[data-gift-preview]'))
        .map(function (c) { return c.dataset.giftPreview; });
      (function next(i) {
        if (i >= keys.length) return;
        var asset = CONFIG[keys[i]];
        if (asset && asset.src) {
          var im = new Image();
          im.addEventListener('load', function () { next(i + 1); });
          im.addEventListener('error', function () { next(i + 1); });
          im.src = asset.src;
        } else next(i + 1);
      })(0);
    }, 240);
  }

  function controlFor(target) {
    return target && target.closest ? target.closest('[data-gift-preview]') : null;
  }

  function panelOpen(group) {
    var panel = group ? group.closest('.cs-mega') : null;
    return panel ? panel.classList.contains('is-open') : false;
  }

  function bindPanel(panel) {
    panel.addEventListener('pointerover', function (e) {
      if (e.pointerType === 'touch') return;
      var control = controlFor(e.target);
      if (!control) return;
      if (control.contains(e.relatedTarget)) return;
      if (panelOpen(panel)) warmGroup(control.closest('.cs-fg__group'));
      schedule(control, true);
    });
    panel.addEventListener('pointerout', function (e) {
      var control = controlFor(e.target);
      if (control && !control.contains(e.relatedTarget)) cancel(control);
    });
    panel.addEventListener('focusin', function (e) {
      var control = controlFor(e.target);
      if (control) schedule(control, false);
    });
  }

  function init() {
    var panels = document.querySelectorAll('.cs-mega[data-cs-mega-panel]');
    panels.forEach(bindPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme editor: re-bind after a section re-render. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) {
      var panel = e.target.querySelector('.cs-mega[data-cs-mega-panel]');
      if (panel) bindPanel(panel);
    }
  });
})();
